import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

type Props = {
    visible: boolean;
    onHide: () => void;
    urls: string[];
    titulo: string;
}

export default function EscolherRelatorioGeradoDialog({ visible, onHide, urls, titulo }: Props) {

    return (
        <Dialog
            header={<div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                {titulo}
            </div>}
            visible={visible}
            style={{ width: "450px" }}
            onHide={() => onHide()}
            footer={
                <div>
                    <Button
                        label="OK"
                        onClick={() => onHide()}
                    />
                </div>
            }
        >
            <div>

                {urls.map((url, index) => (
                    <a
                        key={index}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            padding: "12px 16px",
                            borderRadius: "12px",
                            border: "1px solid #e5e7eb",
                            background: "#fafafa",
                            marginBottom: "10px",
                            textDecoration: "none",
                            color: "#333",
                            fontWeight: 500,
                            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                            transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f0f0f0";
                            e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#fafafa";
                            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
                        }}
                    >
                        <FontAwesomeIcon
                            icon={"file-pdf"}
                            color={"#E53935"}
                            style={{ fontSize: "20px" }}
                        />
                        <span>Relatório {index + 1}</span>
                    </a>

                ))}

            </div>
        </Dialog>
    )
}